import CategoriesPlans from "./pages/categoriesPlans";
import FormCategoriesPlans from "./pages/form";

export const CategoriesPlansRoutes = [
  {
    path: "/configuracoes/tabelas/categorias-planos",
    component: CategoriesPlans,
  },
  {
    path: "/configuracoes/tabelas/categorias-planos/novo",
    component: FormCategoriesPlans,
  },
  {
    path: "/configuracoes/tabelas/categorias-planos/editar/:id",
    component: FormCategoriesPlans,
  },
];
